import NewsAlertModals from "./modals/NewsAlertModals";
import NewsAlertsTable from "./news-alerts-table";

const NewsAlertsContent = () => {
  return (
    <div className="flex flex-col gap-4 mx-auto w-full px-16">
      <NewsAlertsTable />

      {/* Modals */}
      <NewsAlertModals />
    </div>
  );
};

export default NewsAlertsContent;
